import { FC } from "preact/compat";
import { Navigate, Outlet } from "react-router-dom";
import { useApp } from "~/core";

const Public: FC = () => {
    const { me } = useApp();

    if (me.me.value && me.loading.value === false) {
        return <Navigate to="/me" replace />;
    }

    return (
        <div className="flex items-center justify-center w-screen h-screen bg-gradient-to-br from-blue-800 to-sky-900">
            {!me.loading.value && <Outlet />}
        </div>
    );
};

export default Public;
